import { inject } from "aurelia-framework";
import { Redirect } from "aurelia-router";
import { I18N } from "aurelia-i18n";

import { default as apiHelper } from "helpers/apiHelper";
import { default as dateHelper } from "helpers/dateHelper";
import { default as settingHelper } from "helpers/settingHelper";
import { default as notificationHelper } from "helpers/notificationHelper";

import { default as templateService } from "services/templateService";
import { default as materialRequisitionService } from "services/materialRequisitionService";
import { default as queryStringHelper } from "helpers/queryStringHelper";
import { default as routerHelper } from "helpers/routerHelper";
import serviceService from "services/serviceService";
import { default as enumHelper } from "helpers/enumHelper";

@inject(I18N)
export default class MaterialRequisitionItem {
    workOrderId;
    lineNo = '';
    requisitionDate = null;
    requisitionId = '';
    showNotInCatalog = false;
    readonly = false;

    constructor(i18n) {
        this.i18n = i18n;
    }
    canActivate() {
        if (!settingHelper.hasDispatchModel()) {
            notificationHelper.showWarning(this.i18n.tr("DispatchModelRequired"));
            return new Redirect("Settings");
        }
        return true;
    }

    activate(params) {

        if (params.q) {
            var paramsQs = routerHelper.getQuerystring(params.q);
            if (paramsQs && paramsQs.readonly !== "undefined" && paramsQs.readonly) {
                this.readonly = queryStringHelper.parseReadonly(params.q);
            }
        }

        this.bindViewModel(params.workOrderId, params.requisitionId, dateHelper.dateFromNavigationParameter(params.requisitionDate), params.lineNo);

        return templateService.getUserTemplateConfigs().done((configs) => {
            this.showNotInCatalog = configs.ShowNotInCatalogMaterialFieldService;
        });
    }

    setSpecificFields(item) {
        item.WorkOrderId = this.workOrderId;
        return item;
    }

    bindViewModel(workOrderId, requisitionId, requisitionDate, lineNo) {
        this.catalogBaseUrl = apiHelper.getBaseUrl() + "/catalog/fieldservices/materialrequisitions?dispatchTemplateId=" + settingHelper.getSelectedDispatchModel();
        this.workOrderId = workOrderId;
        this.requisitionDate = requisitionDate;
        this.requisitionId = requisitionId;

        this.lineNo = lineNo;

        this.actions = {
            setSpecificFields: item => this.setSpecificFields(item),
            saveMaterialRequisitionItem: (requisitionId, lineNo, item) => materialRequisitionService.setMaterialRequisitionItemForFieldService(this.workOrderId, requisitionId, lineNo, item),
            getActivities: () => serviceService.getWorkorderActivitiesByTypes(this.workOrderId, enumHelper.workOrderActivityType().MATERIAL)
        };
    }
}